import { render, staticRenderFns } from "./agentDetail.vue?vue&type=template&id=0e71e9d2&scoped=true&"
import script from "./agentDetail.vue?vue&type=script&lang=ts&"
export * from "./agentDetail.vue?vue&type=script&lang=ts&"
import style0 from "./agentDetail.vue?vue&type=style&index=0&id=0e71e9d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e71e9d2",
  null
  
)

export default component.exports